import { SmartSpaceVisitData } from '@/store/trainee/trainee.types';
import { PractitionerDto } from '@ecdlink/core';
import { TraineeOnBoardTimeline } from '@ecdlink/graphql';

export enum CoachSmartSpaceChecklisstStepsSteps {
  INITIAL = 1,
  PROGRAMME_DETAILS = 2,
  HEALTH_SANITATION_SAFETY = 3,
  SAFETY_STRUCTURE_AREA = 4,
  SPACE_EMERGENCY_PLANNING = 5,
}

export interface CoachSmartSpaceChecklistProps {
  coachSmartSpaceVisitId: string;
  traineeChecklistVisitId: string;
  timeline?: TraineeOnBoardTimeline;
  practitioner: PractitionerDto;
  saveSmartSpaceCheckData: (
    value: SmartSpaceVisitData[],
    visitSection: string
  ) => void;
  handleNextSection: () => void;
}

export const yesNoOptions = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
];

export enum CoachSmartSpaceChecklistSteps {
  SMART_SPACE_CHECK = 1,
  ADDITIONAL_STANDARDS = 2,
  SAFETY_STRUCTURE_AREA = 3,
}
